import React, { useState, useRef, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import { AwesomeButton } from "react-awesome-button";
import { Row, Col, Form, Card, Button } from "react-bootstrap";
import classes from "./SupplyIn.module.css";
import axios from "axios";
import ModalOkay from "./Modals/ModalOkay";
import { AutoComplete, Divider } from "rsuite";
import "rsuite/dist/rsuite.css";
import InputText from "../Elements/InputText.jsx";
import InputSelect from "../Elements/InputSelect.jsx";
import PermissionContext from "../../Store/permission-context";
const ChangePrice = () => {
  const PCtx = useContext(PermissionContext);
  const [Itemname, setItemname] = useState("");
  const [ItemID, setItemID] = useState("");
  const [QUnit, setQUnit] = useState("");
  const [CostPrice, setCostPrice] = useState("");
  const [Newname, setNewname] = useState("");
  const [Converter, setConverter] = useState("");
  const [SP1, setSP1] = useState("");
  const [SP2, setSP2] = useState("");
  const [SP3, setSP3] = useState("");
  const [UP1, setUP1] = useState("");
  const [UP2, setUP2] = useState("");
  const [UP3, setUP3] = useState("");

  const [IUP1, setIUP1] = useState("");
  const [IUP2, setIUP2] = useState("");
  const [IUP3, setIUP3] = useState("");

  const [IQUnit, setIQUnit] = useState("");
  const [IConverter, setIConverter] = useState("");
  const [AxiosError, setAxiosError] = useState("");
  const [bulkvalue, setbulkvalue] = useState("Carton");
  const [checkup, setcheckup] = useState(true);
  const [checksp, setchecksp] = useState(true);
  const [ErrorSP1, setErrorSP1] = useState(false);
  const [ErrorSP2, setErrorSP2] = useState(false);
  const [ErrorSP3, setErrorSP3] = useState(false);
  const [ErrorUP1, setErrorUP1] = useState(false);
  const [ErrorUP2, setErrorUP2] = useState(false);
  const [ErrorUP3, setErrorUP3] = useState(false);

  const [convreadonly, setconvreadonly] = useState(false);
  const [readonly, setreadonly] = useState(true);
  const [ItemHasChanged, setItemHasChanged] = useState(false);
  const [AllGoodNames, setAllGoodNames] = useState([]);
  const [AllGoodIds, setAllGoodIds] = useState([]);
  const [Itemdetails, setItemdetails] = useState([]);
  const [ShowOkAlert, setShowOkAlert] = useState(false);
  const [ThereisChange, setThereisChange] = useState(false);
  const [Okmessage, setOkmessage] = useState("");
  const [Oktitle, setOktitle] = useState("");
  const ConverterRef = useRef(null);
  const SP1Ref = useRef(null);
  const SP2Ref = useRef(null);
  const SP3Ref = useRef(null);
  const UP1Ref = useRef(null);
  const UP2Ref = useRef(null);
  const UP3Ref = useRef(null);

  // const { addToast } = useToasts();

  const checkboxHandler = (e) => {
    if (e.target.checked) {
      setreadonly(false);
    } else {
      setreadonly(true);
    }
  };

  const CheckUnitPrice = () => {
    setcheckup(!checkup);
  };

  // To load stored items from the database
  useEffect(() => {
    let Allnames = [];
    let AllIDs = [];
    const getData = async () => {
      let AllGoods = await PCtx.connectAxios("getallgoods.php", "");

      for (var y = 0; y < AllGoods.length; y++) {
        AllIDs[y] = AllGoods[y][0];
        Allnames[y] = AllGoods[y][1];
      }
    };
    getData();
    setAllGoodNames(Allnames);
    setAllGoodIds(AllIDs);
  }, []);

  useEffect(() => {
    let up = parseFloat(CostPrice) / parseFloat(Converter);
    if (parseFloat(UP1Ref.current.value) >= 0 && UP1Ref.current.value < up) {
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 1 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );

      setErrorUP1(true);
    } else {
      setErrorUP1(false);
    }
    if (parseFloat(UP2Ref.current.value) >= 0 && UP2Ref.current.value < up) {
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 2 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
      setErrorUP2(true);
    } else {
      setErrorUP2(false);
    }
    if (parseFloat(UP3Ref.current.value) >= 0 && UP3Ref.current.value < up) {
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 3 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
      setErrorUP3(true);
    } else {
      setErrorUP3(false);
    }
  }, [checkup]);

  //This runs whenever the Selling Price is changed to ensure that the carton selling price than carton cost price

  useEffect(() => {
    let itdetails = [
      {
        title: "Item Name",
        value: Itemname === "" ? "No item selected" : Itemname,
      },

      {
        title: "Quantity left (Unit)",
        value: IQUnit === "" ? 0 : IQUnit,
      },

      {
        title: " Unit Selling Price 1",
        value: IUP1 === "" ? "₦0" : "₦" + IUP1,
      },
      {
        title: " Unit Selling Price 1",
        value: IUP2 === "" ? "₦0" : "₦" + IUP2,
      },
      {
        title: " Unit Selling Price 1",
        value: IUP3 === "" ? "₦0" : "₦" + IUP3,
      },
    ];

    setItemdetails(itdetails);
  }, [ItemHasChanged]);

  //To get the item picked
  const getItemnameSelection = async (it) => {
    let goodproperties = await PCtx.connectAxios("getitemdetails.php", it);

    setCostPrice(goodproperties.CostPrice);

    setItemID(goodproperties.GoodID);
    setUP1(goodproperties.UP1);
    setUP2(goodproperties.UP2);
    setUP3(goodproperties.UP3);

    setIUP1(goodproperties.UP1);
    setIUP2(goodproperties.UP2);
    setIUP3(goodproperties.UP3);
    setIQUnit(goodproperties.QUnit);
    setItemHasChanged(!ItemHasChanged);
  };

  const getTypedText = () => {
    let ITN = Itemname.charAt(0).toUpperCase() + Itemname.slice(1);
    if (AllGoodNames.includes(ITN)) {
      getItemnameSelection(ITN);
    } else {
      setCostPrice("");
      setNewname("");

      setQUnit("");
      setConverter("");

      setUP1("");
      setUP2("");
      setUP3("");
    }
  };

  const nextOKEvent = () => {
    setShowOkAlert(false);
    window.location.reload();
  };
  //Submitting the supply form
  const submitItemForm = async (e) => {
    e.preventDefault();
    if (ErrorSP1 || ErrorSP2 || ErrorSP3 || ErrorUP1 || ErrorUP2 || ErrorUP3) {
      PCtx.displayAlert(
        "ERROR IN SAVING",
        Itemname +
          " cannot be saved. Please check the value(s) highlighted in Red.",
        "danger"
      );
    } else {
      let rep = "";
      let IsNewItem = true;
      if (AllGoodNames.includes(Newname)) {
        PCtx.displayAlert(
          "ERROR IN SAVING",
          Newname + " is already existing. Please pick another name",
          "danger"
        );
      } else {
        IsNewItem = false;

        let up1 = UP1 === "" ? 0 : UP1;
        let up2 = UP2 === "" ? 0 : UP2;
        let up3 = UP3 === "" ? 0 : UP3;

        let iup1 = IUP1 === "" ? 0 : IUP1;
        let iup2 = IUP2 === "" ? 0 : IUP2;
        let iup3 = IUP3 === "" ? 0 : IUP3;

        if (parseFloat(up1) !== parseFloat(iup1)) {
          rep +=
            PCtx.Username +
            " Changed the Unit price 1 of " +
            Itemname +
            " from " +
            iup1 +
            " to " +
            up1;
        }
        if (parseFloat(up2) !== parseFloat(iup2)) {
          rep +=
            PCtx.Username +
            " Changed the Unit price 2 of " +
            Itemname +
            " from " +
            iup2 +
            " to " +
            up2;
        }
        if (parseFloat(up3) !== parseFloat(iup3)) {
          rep +=
            PCtx.Username +
            "Changed the Unit price 3 of " +
            Itemname +
            " from " +
            iup3 +
            " to " +
            up3;
        }

        if (Newname !== Itemname && !readonly && Newname != "") {
          rep +=
            PCtx.Username +
            " Changed the name of " +
            Itemname +
            " to " +
            Newname;
        }

        const supplyproperties = {
          myItemname: Itemname,
          myItemID: ItemID,
          myNewname: Newname,
          myCostPrice: CostPrice,
          myUP1: UP1,
          myUP2: UP2,
          myUP3: UP3,
          logreport: rep,
          isNew: IsNewItem,
          staff: PCtx.Username,
        };

        let resp = await PCtx.connectAxios(
          "updateproperties.php",
          supplyproperties
        );

        if (resp.includes("Error")) {
          PCtx.displayAlert(
            "ERROR IN SAVING ITEM",
            "There was an error in saving " +
              Itemname +
              ". Please check all the values you supplied again",
            "danger"
          );
        } else {
          setOkmessage("All Changes saved successfully.");
          setOktitle("SUCCESS!");
          setShowOkAlert(true);
        }
      }
    }
  };
  return (
    <div>
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Divider>
                <h3
                  className="text-center"
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  NEW SUPPLY
                </h3>
              </Divider>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="justify-content-around">
        <Col md={8} sm={12} xs={12} className="mx-0 px-0">
          <Card>
            <Card.Header
              className="text-center text-bg"
              style={{ color: "brown", fontFamily: "Times New Roman" }}
            >
              NEW ITEM FORM
            </Card.Header>
            <Card.Body>
              <Form onSubmit={submitItemForm}>
                <Row className="justify-content-around">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label style={{ color: "brown" }}>
                        Item Name
                      </Form.Label>
                      <AutoComplete
                        data={AllGoodNames}
                        value={Itemname}
                        onChange={setItemname}
                        onSelect={getItemnameSelection}
                        onBlur={getTypedText}
                        style={{ border: "1px solid brown" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col md={4}>
                    <Row>
                      <Col md={1} xs={1} sm={1}>
                        <input type="checkbox" onChange={checkboxHandler} />
                      </Col>
                      <Col md={11} xs={11} sm={11}>
                        <InputText
                          label="Change Item name"
                          labelcolor="brown"
                          myVal={Newname}
                          myName="Converter"
                          myOnChange={setNewname}
                          placeholder="Enter new name here"
                          required={true}
                          readonly={readonly}
                        />
                      </Col>
                    </Row>
                    <hr style={{ padding: "0px", margin: "0px" }} />
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <InputText
                      label="One Unit Selling Price 1"
                      labelcolor="brown"
                      myVal={UP1}
                      myRef={UP1Ref}
                      myName="UP1"
                      myOnChange={setUP1}
                      inputType="number"
                      getAction={CheckUnitPrice}
                      error={ErrorUP1}
                      readonly={Itemname === "" ? true : false}
                    />
                    <hr />
                  </Col>
                  <Col md={4}>
                    <InputText
                      label="One Unit Selling Price 2"
                      labelcolor="brown"
                      myVal={UP2}
                      myRef={UP2Ref}
                      myName="UP2"
                      myOnChange={setUP2}
                      inputType="number"
                      getAction={CheckUnitPrice}
                      error={ErrorUP2}
                      placeholder="Optional"
                      readonly={Itemname === "" ? true : false}
                    />
                    <hr />
                  </Col>
                  <Col md={4}>
                    <InputText
                      label="One Unit Selling Price 3"
                      labelcolor="brown"
                      myVal={UP3}
                      myRef={UP3Ref}
                      myName="UP3"
                      myOnChange={setUP3}
                      inputType="number"
                      getAction={CheckUnitPrice}
                      error={ErrorUP3}
                      readonly={Itemname === "" ? true : false}
                      placeholder="Optional"
                    />
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col md={4} lg={4} xs={4} sm={4} className="offset-4">
                    <Button type="submit">Save Data</Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
        <ModalOkay
          message={Okmessage}
          okshow={ShowOkAlert}
          title={Oktitle}
          nextEvent={nextOKEvent}
        />
      </Row>
    </div>
  );
};

export default ChangePrice;
